import React, { createContext, useRef } from 'react'

export interface Refs {
  barcodeInputRef: React.RefObject<HTMLInputElement>
  barcodeFormRef?: React.RefObject<HTMLFormElement>
  amountInputRef: React.RefObject<HTMLInputElement>
}

export const RefContext = createContext<Refs | null>(null)

export function RefProvider({ children }: { children: React.ReactNode }) {
  const barcodeInputRef = useRef<HTMLInputElement>(null)
  const barcodeFormRef = useRef<HTMLFormElement>(null)
  const amountInputRef = React.useRef<HTMLInputElement>(null)

  const refs: Refs = {
    barcodeInputRef,
    barcodeFormRef,
    amountInputRef,
  }

  return <RefContext.Provider value={refs}>{children}</RefContext.Provider>
}
